/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {CustomerAttachmentDTO} from '@well/domain';
import {Observable} from 'rxjs';
import { AttachmentVO } from '@well/attachment/domain';

@Injectable({
  providedIn: 'root'
})
export class CustomerAttachmentsResourceService extends AbstractResourceService<AttachmentVO, CustomerAttachmentDTO, any, any> {

  constructor(protected httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(httpClient,
      `${environmentService.getEnvironmentProperty('customerAttachmentsUrl')}`,
      CustomerAttachmentDTO
    );
  }

  findAllAttachments(customerUuid: string): Observable<JsonApiResource<AttachmentVO[], any>> {
    return this.httpClient.get(
      `${this.url}/${customerUuid}`).pipe(this.mapToListOfObjects());
  }

  saveAttachemnt(customerUuid: string, customerAttachmentDTO: CustomerAttachmentDTO) {
    return this.httpClient.post<AttachmentVO>(`${this.url}/${customerUuid}`, customerAttachmentDTO, {
      headers: this.headers
    });
  }

}
